import { z } from 'zod'

const TaskSchema = z.object({
  // Common data shared across every task type
  task_id: z.number().nullable(),
  global_task_type_id: z.number(),
  task_type_name: z.string().nullable().optional(),
  global_task_status_id: z.number().nullable().optional(),
  task_status_name: z.string().nullable().optional(),
  program_id: z.number().nullable().optional(),
  submitted_at: z.string().nullable(),
  days_since_submitted: z.number().nullable(),
  // Morph entity related to the task (application_flag_id | payment_id | provider_item_id)
  related_entity_id: z.number().nullable().optional(),

  // Provider item tasks (global_task_type_id === 4)
  provider_id: z.number().nullable().optional(),
  provider_name: z.string().nullable().optional(),
  provider_item_name: z.string().nullable().optional(),

  // Application flag / appeal tasks (global_task_type_id === 1 | 2)
  scholarship_application_id: z.number().nullable().optional(),
  application_flags_id: z.number().nullable().optional(),
  show_combinated_flags: z.array(z.string()).nullable().optional(),
})

// Array of tasks
const TasksArraySchema = z.array(TaskSchema)

// Type inference
type Task = z.infer<typeof TaskSchema>
type Tasks = z.infer<typeof TasksArraySchema>

export { TaskSchema, TasksArraySchema, type Task, type Tasks }
